/* eslint-disable indent */
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import dataToPoints from './dataProcessing/dataToPoints';
export const SparklinesLine = ({
  data = [],
  margin = 0,
  color = '#25948C',
  style,
  max,
  min,
  width,
  height,
  limit,
  fontSize
}) => {
  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
      x: 10,
      y: height && height / 2,
      fill: color,
      fontSize: fontSize
    }, "No value recorded"));
  }

  const points = dataToPoints({
    data,
    limit,
    width: width,
    height: height,
    margin,
    max,
    min
  });
  const linePoints = points && points.map(p => [p.x, p.y]).reduce((a, b) => a.concat(b));
  const closePolyPoints = points && height && margin >= 0 ? [points[points.length - 1].x, height, // height - margin,
  margin, height, // height - margin,
  margin, points[0].y] : [];
  const fillPoints = linePoints && linePoints.concat(closePolyPoints);
  const lineStyle = {
    stroke: color || style && style.stroke,
    strokeWidth: style && style.strokeWidth || '1',
    strokeLinejoin: style && style.strokeLinejoin || 'round',
    strokeLinecap: style && style.strokeLinecap || 'round',
    fill: 'none'
  };
  const fillStyle = {
    stroke: style && style.stroke || 'none',
    strokeWidth: '0',
    fillOpacity: style && style.fillOpacity || '0',
    // fill: color || (style && style.fill),
    fill: 'none',
    pointerEvents: 'auto'
  };
  const tooltipStyle = {
    stroke: 'none',
    strokeWidth: '0',
    fill: 'none'
  };
  const tooltips = points && data && points.map((p, i) => /*#__PURE__*/React.createElement(Tooltip, {
    title: data[i],
    key: `${data[i]}-${p.x}`
  }, /*#__PURE__*/React.createElement("circle", {
    key: `${data[i]}-${p.x}`,
    cx: p.x,
    cy: p.y,
    r: 2,
    style: tooltipStyle
  })));
  return /*#__PURE__*/React.createElement("g", null, tooltips, /*#__PURE__*/React.createElement("polyline", {
    points: fillPoints === null || fillPoints === void 0 ? void 0 : fillPoints.join(' '),
    style: fillStyle
  }), /*#__PURE__*/React.createElement("polyline", {
    points: linePoints === null || linePoints === void 0 ? void 0 : linePoints.join(' '),
    style: lineStyle
  }));
};
export default SparklinesLine;